import React from "react";
import styles from "./hero.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowRight, faCheck, faCode, faLaptop} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const Hero: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className={styles.sectionWrapper}>

            {/* YOUR GRID — UNTOUCHED */}
            <div className={styles.gridContainer}>
                <div className={styles.leftContainer}>
                    <h1 className={styles.headline}>
                        Custom Web Design That Drives Business Growth.
                    </h1>
                    <div className={styles.sub_headLine}>
                        <p>
                            Modern, fast websites tailored to your business,
                            built to convert visitors into customers with strategically placed content.
                        </p>
                    </div>
                    <a href="/contact" className={styles.btnPrimary}>
                        Get a Free Quote
                    </a>
                </div>
                {/* WHAT YOU GET*/}
                <div className={styles.card}>
                    <div className={styles.card_title}>
                        WHAT YOU GET
                    </div>
                    <div className={styles.content}>
                        <div className={styles.listItem}>
                            <div className={styles.icon_container}>
                                <FontAwesomeIcon icon={faCheck} style={{color:"darkturquoise"}}/>
                            </div>
                            <p className={styles.listItemText}>A modern design aligned with your brand</p>
                        </div>
                        <div className={styles.listItem}>
                            <div className={styles.icon_container}>
                                <FontAwesomeIcon icon={faCheck} style={{color:"darkturquoise"}}/>
                            </div>
                            <p className={styles.listItemText}>Fully responsive layouts</p>
                        </div>
                        <div className={styles.listItem}>
                            <div className={styles.icon_container}>
                                <FontAwesomeIcon icon={faCheck} style={{color:"darkturquoise"}}/>
                            </div>
                            <p className={styles.listItemText}>Speed-optimized pages</p>
                        </div>
                        <div className={styles.listItem}>
                            <div className={styles.icon_container}>
                                <FontAwesomeIcon icon={faCheck} style={{color:"darkturquoise"}}/>
                            </div>
                            <p className={styles.listItemText}>Clean UI/UX your customers will love</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
